import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'save-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		context: {
			type: String,
			default: ''
		}
	},
	computed: {
		...mapGetters([
			'getClass',
			'getHomeworkList',
			'getAgendaDate'
		])
	},
	methods: {
		...mapActions([
			'saveHomeworkBySchoolClass',
			'getLoggedUser',
			'setHomeworkList',
			'putAgendaExclusiveHomework'
		]),
		saveHomeworks() {

			this.saveHomeworkBySchoolClass({
				schoolClass: {
					schoolClassId: this.getClass.schoolClassId
				},
				date: (typeof this.getAgendaDate === 'object' ? this.getAgendaDate.toISOString() : this.getAgendaDate).split('T')[0],
				themes: this.getHomeworkList,
				user: this.getLoggedUser
			}).then(() => {

				EventBus.$emit('homeworkSaved');

				toastr.success(this.$gettext('Lição de casa salva com sucesso!'));

			});

		},
		addExclusiveHomeworks() {

			this.putAgendaExclusiveHomework({
				date: (typeof this.getAgendaDate === 'object' ? this.getAgendaDate.toISOString() : this.getAgendaDate).split('T')[0],
				themes: this.getHomeworkList,
				user: this.getLoggedUser
			}).then(() => {
				toastr.success(this.$gettext('Lição de casa salva com sucesso!'));
			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/save/index.js